<div class="registration-add" fxLayout="column" fxLayoutGap="15px" [formGroup]="registrationForm">
  <div class="status-info">
    <app-dict
      [label]="'Status'" [dictType]="'registration_status'"
      formControlName="status"
      [control]="statusControl"
      [required]="true"
      [multiple]="false"
      appearance="fill"
      [color]="true"
      (selectedDict)="statusChanged($event)"
    ></app-dict>
  </div>
  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="processingRequest || !registrationFormValid"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px" fxLayout="column">
      <div fxLayout="row">
        <mat-card fxLayout="column" fxLayoutGap="15px" fxFlex="100">
          <div fxLayout="row">
            <h3>Dane rejestracji</h3>
          </div>

          <div fxLayout="row">
            <app-detail fxFlex="100" header="OFWCA" [value]="registrationObject.ofwca?.fullName"></app-detail>
          </div>

          <div fxLayout="row">
            <mat-slide-toggle fxFlex="100" color="accent" formControlName="showAllContracts">Pokaż wszystkie umowy</mat-slide-toggle>
          </div>

          <div fxLayout="row" *ngIf="showAllContracts">
            <app-dict-all-contracts fxFlex="100" label="Umowa" [control]="contractControl" [required]="true" [filterPartnership]="true"
                                    (selectedContract)="contractChanged($event)" [showOwnerName]="true"
                                    [showStatus]="true"></app-dict-all-contracts>
          </div>

          <div fxLayout="row" *ngIf="!showAllContracts">
            <app-dict-contracts fxFlex="100" label="Umowa"  [control]="contractControl" [required]="true" [contracts]="ofwcaContracts"
                                (selectedContract)="contractChanged($event)" [showOwnerName]="true"
                                [showStatus]="true"></app-dict-contracts>
          </div>

          <div fxLayout="row">
            <app-dict-insurance-companies fxFlex="100" label="TU" [required]="true" [control]="insuranceCompanyControl"
                                          [companyId]="contractCompanyId" (selectedInsuranceCompany)="insuranceCompanyChanged($event, false)"
                                          [hideChildren]="true" [forceShowPzu]="selectedContract?.type?.key === CONTRACT_TYPE_PROFIT"
                                          [forceShowBalcia]="selectedContract?.type?.key === CONTRACT_TYPE_PROFIT"
                                          [forceShowInsuranceCompanyIds]="forceShowInsuranceCompanyId ? [forceShowInsuranceCompanyId] : null"
            ></app-dict-insurance-companies>
          </div>

          <div fxLayout="row" fxLayoutGap="15px">
            <app-dict fxFlex="100" label="Co jest potrzebne?" [required]="true" [control]="whatIsNeededControl" dictType="registration_what_is_needed"
                      (selectedDict)="whatIsNeededChanged($event)"></app-dict>
<!--            <app-dict fxFlex="50" label="Podwójna rejestracja" [required]="true" [control]="doubleRegistrationControl" dictType="double_registration"></app-dict>-->
          </div>

          <div *ngIf="(userPermissionss | async).registration.admin_root" fxLayout="row" fxLayoutGap="15px">
            <app-dict fxFlex="100" label="Jaki egzamin potrzebny" [required]="false" [control]="missingExamControl" dictType="exam_type"
            ></app-dict>
          </div>

          <div fxLayout="row"  fxLayoutGap="15px">
            <mat-error fxFlex="100" *ngIf="doubleRegistrationControl.hasError('backendError')">{{doubleRegistrationControl.getError('backendError')}}</mat-error>
          </div>
          <ng-container *ngIf="!disable">
          <div fxLayout="row" fxLayoutGap="15px" *ngIf="availableSalesProfiles">
            <app-dict fxFlex="100" label="Profile/systemy sprzedażowe" [required]="true" [multiple]="true"  [control]="salesProfilesControl"
                      [dictTypeSubject]="salesProfilesDictTypeSubject"></app-dict>
          </div>
          </ng-container>

        </mat-card>
      </div>
      <div fxLayout="row" *ngIf="(userPermissionss | async).registration.admin_root" >
        <mat-card fxLayout="column" fxLayoutGap="15px" fxFlex="100">
          <div fxLayout="row">
            <h3>Hiperio</h3>
          </div>
          <div fxLayout="row" fxLayoutGap="15px">
            <mat-slide-toggle color="accent" formControlName="hiperioTestAccess">Hiperio dostęp testowy</mat-slide-toggle>
            <mat-error *ngIf="registrationForm.get('hiperioTestAccess').hasError('backendError')">
              {{registrationForm.get('hiperioTestAccess').getError('backendError')}}
            </mat-error>
          </div>

        </mat-card>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100" *ngIf="CHRONIE_INSURANCE_COMPANIES.includes(selectedInsuranceCompany?.key)">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Chronie.pl</h3>
            </div>

            <div fxLayout="row" *ngIf="!selectedOfwca || !selectedOfwca.chronieLogin">
              <div fxFlex="100">
                <mat-form-field fxFlex="100">
                  <mat-label>Login</mat-label>
                  <input [required]="true" matInput placeholder="adres@asf24.pl" [formControl]="chronieLoginControl" [disabled]="disable">
                  <mat-error *ngIf="registrationForm.get('chronieLogin').hasError('email')">Podaj prawidłowy adres email</mat-error>
                  <mat-error *ngIf="registrationForm.get('chronieLogin').hasError('backendError')">
                    {{registrationForm.get('chronieLogin').getError('backendError')}}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div fxLayout="row" *ngIf="!(!selectedOfwca || !selectedOfwca.chronieLogin)">
              <app-detail fxFlex="100" header="Login" [value]="selectedOfwca.chronieLogin" ></app-detail>
            </div>
          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100" *ngIf="selectedInsuranceCompany?.key === IC_LINK4">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Dane do rejestracji Link 4</h3>
            </div>


            <div fxLayout="row">
              <div fxFlex="100">
                <mat-form-field fxFlex="100">
                  <mat-label>NIP</mat-label>
                  <input [required]="true" matInput placeholder="NIP" formControlName="registrationNip">
                  <mat-error *ngIf="registrationForm.get('registrationNip').hasError('invalidNip')">Podaj prawidłowy numer NIP</mat-error>
                </mat-form-field>
              </div>
            </div>

            <div fxLayout="row">
              <div fxFlex="100">
                <mat-form-field fxFlex="100">
                  <mat-label>Wlaściciel OFWCA Partner (Imię i Nazwisko, jeśli nie ma Właściciela to imię i nazwisko Koordynatora)</mat-label>
                  <input  [required]="true" matInput placeholder="Wlaściciel OFWCA Partner (Imię i Nazwisko, jeśli nie ma Właściciela to imię i nazwisko Koordynatora)" formControlName="registrationOfwcaOwner">
                </mat-form-field>
              </div>
            </div>

            <div fxLayout="row">
              <div fxFlex="100">
                <mat-form-field fxFlex="100">
                  <mat-label>Nazwa Firmy Partner</mat-label>
                  <input  [required]="true" matInput placeholder="Nazwa Firmy Partner" formControlName="registrationCompanyName">
                </mat-form-field>
              </div>
            </div>

            <div fxLayout="row">
              <div fxFlex="100">
                <mat-form-field fxFlex="100">
                  <mat-label>Email podstawowy Partnera</mat-label>
                  <input [required]="true" matInput placeholder="Email podstawowy Partnera" formControlName="registrationPartnerEmail">
                  <mat-error *ngIf="registrationForm.get('registrationPartnerEmail').hasError('email')">Podaj prawidłowy adres email</mat-error>
                </mat-form-field>
              </div>
            </div>

            <app-address-form title="Adres Placówki" [addressForm]="registrationFacilityAddressGroup"></app-address-form>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100" *ngIf="selectedInsuranceCompany?.key === IC_PZU || selectedInsuranceCompany?.key === IC_PZU_LIFE">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3 [fxFlex]="'88'">{{selectedInsuranceCompany?.key === IC_PZU ? 'Dane do weryfikacji PZU': 'Dane do weryfikacji PZU Życie'}}</h3>

              <div  fxLayout="row" fxFlex="5" class="button-exit" >
                <button (click)="downloadPartner()"  mat-icon-button color="primary" matTooltip="Skopiuj dane partnera"><mat-icon>download</mat-icon></button>
              </div>
            </div>

            <app-address-form title="Adres biura/Miejsce pracy OFWCA" [required]="false"  [simple]="true" [requirePzuData]="true"[addressForm]="registrationFacilityAddressPzuGroup"></app-address-form>

            <mat-card>
              <div fxLayout="row">
                <h3>Dane podmiotu sprzedaży</h3>
              </div>

              <div fxLayout="row">
                <div fxFlex="100">
                  <mat-form-field fxFlex="100">
                    <mat-label>Nazwa agencji</mat-label>
                    <input [required]="false" matInput placeholder="Nazwa agencji" formControlName="registrationAgencyName">
                    <mat-error *ngIf="registrationForm.get('registrationAgencyName').hasError('required')">To pole jest wymagane</mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div fxLayout="row">
                <div fxFlex="100">
                  <mat-form-field fxFlex="100">
                    <mat-label>NIP</mat-label>
                    <input [required]="false" matInput placeholder="NIP" formControlName="registrationNip">
                    <mat-error *ngIf="registrationForm.get('registrationNip').hasError('required')">To pole jest wymagane</mat-error>
                    <mat-error *ngIf="registrationForm.get('registrationNip').hasError('invalidNip')">Podaj prawidłowy numer NIP</mat-error>
                  </mat-form-field>
                </div>
              </div>

<!--              <div fxLayout="row">-->
<!--                <app-dict fxFlex="100" label="Segment" [required]="true" [control]="registrationSegmentControl" dictType="segment_type"></app-dict>-->
<!--              </div>-->

            </mat-card>
          </mat-card>
        </div>

      </div>

      <div fxLayout="row" fxFlex.lt-md="100" *ngIf="selectedInsuranceCompany?.key === IC_PZU || selectedInsuranceCompany?.key === IC_LINK4 || selectedInsuranceCompany?.key === IC_PZU_LIFE">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3 >Dane rejestracji</h3>

            </div>

            <div fxLayout="row">
              <mat-form-field fxFlex="100">
                <mat-label>Email</mat-label>
                <input matInput placeholder="adres@asf.com.pl" formControlName="additionalEmail" [required]="false">
                <mat-error *ngIf="registrationForm.get('additionalEmail').hasError('email')">Podaj prawidłowy adres email</mat-error>
              </mat-form-field>
            </div>



            <div fxLayout="row">
              <mat-form-field fxFlex="100">
                <mat-label>Numer telefonu</mat-label>
                <input matInput placeholder="+48 500 200 300" formControlName="additionalPhone" [required]="false" prefix="+48" mask=" 000 000 000">
              </mat-form-field>
            </div>

          </mat-card>
        </div>
      </div>


      <div fxLayout="row" fxFlex.lt-md="100" *ngIf="requireCompensaData">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Dane do rejestracji Compensa</h3>
            </div>

<!--            <div fxLayout="row">-->
<!--              <app-dict fxFlex="100" label="Biuro Compensa" [required]="true" [control]="registrationCompensaOfficeControl"-->
<!--                        [dictType]="selectedContract?.type.key === CONTRACT_TYPE_PROFIT ? 'compensa_office_profit' : 'compensa_office'"></app-dict>-->
<!--            </div>-->
<!--            <div fxLayout="row" *ngIf="registrationCompensaWienerManagerControl.enabled">-->
<!--              <app-dynamic-dict fxFlex="100" label="Manager Wiener" [required]="true" [control]="registrationCompensaWienerManagerControl" [dictType]="DYNAMIC_DICTIONARY_MANAGER_WIENER"></app-dynamic-dict>-->
<!--            </div>-->
            <div fxLayout="row">
              <app-dynamic-dict fxFlex="100" label="Biuro Compensa" [required]="true" [control]="registrationCompensaOfficeNewControl" [dictType]="selectedContract?.type.key === CONTRACT_TYPE_PROFIT ? DYNAMIC_DICTIONARY_COMPENSA_OFFICE_PROFIT : DYNAMIC_DICTIONARY_COMPENSA_OFFICE"></app-dynamic-dict>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100" *ngIf="requireCompensaLifeData">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Dane do rejestracji Vienna Life</h3>
            </div>

            <div fxLayout="row">
              <app-dict fxFlex="100" label="Biuro" [required]="true" [control]="registrationCompensaLifeOfficeControl"
                        [dictType]="'compensa_office_life'"></app-dict>
            </div>
          </mat-card>
        </div>
      </div>

<!--      <div fxLayout="row" fxFlex.lt-md="100" *ngIf="requireTrastiData">-->
<!--        <div fxFlex="100">-->
<!--          <mat-card>-->
<!--            <div fxLayout="row">-->
<!--              <h3>Dane do rejestracji Trasti</h3>-->
<!--            </div>-->


<!--            <div fxLayout="row">-->
<!--              <div fxFlex="100">-->
<!--                <mat-form-field fxFlex="100">-->
<!--                  <mat-label>Unikatowy adres email</mat-label>-->
<!--                  <input [required]="true" matInput placeholder="adres@asf24.pl" formControlName="trastiEmail">-->
<!--                  <mat-error *ngIf="registrationForm.get('trastiEmail').hasError('email')">Podaj prawidłowy adres email</mat-error>-->
<!--                  <mat-error *ngIf="registrationForm.get('trastiEmail').hasError('backendError')">-->
<!--                    {{registrationForm.get('trastiEmail').getError('backendError')}}-->
<!--                  </mat-error>-->
<!--                </mat-form-field>-->
<!--              </div>-->
<!--            </div>-->

<!--          </mat-card>-->
<!--        </div>-->
<!--      </div>-->

    </div>

    <div fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px" fxLayout="column">
      <div fxLayout="row">
        <mat-card fxLayout="column" fxLayoutGap="15px" fxFlex="100">
          <div fxLayout="row">
            <h3>Szczegóły</h3>
          </div>

<!--          <div fxLayout="row" *ngIf="registrationObject.insuranceCompany.key === IC_ALLIANZ">-->
<!--            <div fxFlex="100">-->
<!--              <mat-slide-toggle color="accent" formControlName="hasAllianzCert">Certyfikat Allianz</mat-slide-toggle>-->
<!--              Certyfikat Allianz dodawanie edycja-->
<!--            </div>-->
<!--          </div>-->

          <ng-container *ngIf="registrationObject.insuranceCompany.key === IC_PZU || registrationObject.insuranceCompany.key === IC_PZU_LIFE">
            <div fxLayout="row">
              <div fxFlex="100">
                <mat-slide-toggle color="accent" formControlName="sentToPzuForVerification">Wysłano do weryfikacji PZU</mat-slide-toggle>
              </div>
            </div>
            <div fxLayout="row">
              <div fxFlex="100">
                <mat-slide-toggle color="accent" formControlName="agreedToRegisterInPzu">Zgoda na rejestrację w PZU</mat-slide-toggle>
              </div>
            </div>
            <div fxLayout="row">
              <div fxFlex="100">
                <mat-slide-toggle color="accent" formControlName="pzuVerificationSupplement">Dodatkowa weryfikacja PZU</mat-slide-toggle>
              </div>
            </div>
            <div fxLayout="row">
              <div fxFlex="100">
                <mat-slide-toggle color="accent" formControlName="consentsAndDeclarations">Zgody i oświadczenia w aplikacji kandydat</mat-slide-toggle>
              </div>
            </div>
          </ng-container>

          <div fxLayout="row">
            <div fxFlex="100">
              <mat-slide-toggle  color="accent" formControlName="statements">Oświadczenia komplet</mat-slide-toggle>
            </div>
          </div>

          <ng-container *ngIf="registrationObject.insuranceCompany.key === IC_PZU_LIFE || registrationObject.insuranceCompany.key === IC_PZU  ">
            <div fxLayout="row">
              <div fxFlex="100">
                <mat-slide-toggle color="accent" formControlName="importedToCandidateApplication">Zaimportowany do aplikacji kandydat</mat-slide-toggle>
              </div>
            </div>
          </ng-container>

          <div fxLayout="row" fxLayoutGap="15px">
            <div fxFlex="50">
              <app-datepicker
                label="Data wpływu oświadczeń do centrali"
                placeholder="2000-01-01" color="accent"
                [required]="false"
                [control]="dateOfReceiptOfStatementsControl"
              ></app-datepicker>
            </div>

            <div fxFlex="50">
              <app-datepicker
                label="Data wysłania do rejestracji do TU"
                placeholder="2000-01-01"
                [required]="false"
                [control]="sentToInsuranceCompanyToRegisterDateControl"
              ></app-datepicker>
            </div>
          </div>

          <div fxLayout="row">
            <div fxFlex="100">
              <app-datepicker
                label="Data zarejestrowania"
                placeholder="2000-01-01"
                [required]="false"
                [control]="dateOfRegistrationControl"
              ></app-datepicker>
            </div>
          </div>

          <div fxLayout="row" *ngIf="!registrationForm.get('statements').value">
            <mat-form-field fxFlex="100">
              <mat-label>Brakujące oświadczenia</mat-label>
              <textarea  [required]="false" formControlName="missingStatements" matInput placeholder="Brakujące oświadczenia"></textarea>
            </mat-form-field>
          </div>

        </mat-card>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100" *ngIf="userPermissions.registration.id_import">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Relacje</h3>
            </div>

            <div fxLayout="row">

              <app-dict-regionals fxFlex="100"  label="Regionalny (majątek)"   [control]="assetsRegionalControl"  ></app-dict-regionals>

            </div>

            <div fxLayout="row">

              <app-dict-regionals fxFlex="100"  label="Regionalny (życie)"  [control]="lifeRegionalControl"  ></app-dict-regionals>

            </div>


          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100" *ngIf="(userPermissionss | async).registration.id_import  ">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Podwójna rejestracja</h3>
            </div>

            <div fxLayout="row">
              <ng-container *ngIf="registrationIdForms.hasOwnProperty(REGISTRATION_ID_TYPE_SENT)">
                <div
                  [formGroup]="registrationIdForms[REGISTRATION_ID_TYPE_SENT].formGroup"
                >
                  <ng-container >
                    <div class="box0">
                      <div fxLayout="column" fxLayoutGap="15px">
                        <div fxLayout="row">
                          <app-slide-toggle
                            [header]="registrationIdForms[REGISTRATION_ID_TYPE_SENT].identifierName"
                            [control]="getControl(registrationIdForms[REGISTRATION_ID_TYPE_SENT].formGroup, 'value')"
                            [trueValue]="'Tak'"
                            [falseValue]="'Nie'"
                          ></app-slide-toggle>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
                <span fxFlex="2"></span>
              </ng-container>
            </div>

            <div fxLayout="row" *ngIf="registrationObject.insuranceCompany.registrationIdTypes.includes(REGISTRATION_ID_TYPE_REQUEST_FOR_DELETION_SENT)">
              <ng-container *ngIf="registrationIdForms.hasOwnProperty(REGISTRATION_ID_TYPE_REQUEST_FOR_DELETION_SENT)">
                <div
                  [formGroup]="registrationIdForms[REGISTRATION_ID_TYPE_REQUEST_FOR_DELETION_SENT].formGroup"
                >
                  <ng-container >
                    <div class="box0">
                      <div fxLayout="column" fxLayoutGap="15px">
                        <div fxLayout="row">
                          <app-slide-toggle
                            [header]="registrationIdForms[REGISTRATION_ID_TYPE_REQUEST_FOR_DELETION_SENT].identifierName"
                            [control]="getControl(registrationIdForms[REGISTRATION_ID_TYPE_REQUEST_FOR_DELETION_SENT].formGroup, 'value')"
                            [trueValue]="'Tak'"
                            [falseValue]="'Nie'"
                          ></app-slide-toggle>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
                <span fxFlex="2"></span>
              </ng-container>
            </div>

            <div fxLayout="row" *ngIf="registrationObject.insuranceCompany.registrationIdTypes.includes(REGISTRATION_ID_TYPE_CONSENT_TO_DUAL_REGISTRATION)">
              <ng-container *ngIf="registrationIdForms.hasOwnProperty(REGISTRATION_ID_TYPE_CONSENT_TO_DUAL_REGISTRATION)">
                <div
                  [formGroup]="registrationIdForms[REGISTRATION_ID_TYPE_CONSENT_TO_DUAL_REGISTRATION].formGroup"
                >
                  <ng-container >
                    <div class="box0">
                      <div fxLayout="column" fxLayoutGap="15px">
                        <div fxLayout="row">
                          <app-slide-toggle
                            [header]="registrationIdForms[REGISTRATION_ID_TYPE_CONSENT_TO_DUAL_REGISTRATION].identifierName"
                            [control]="getControl(registrationIdForms[REGISTRATION_ID_TYPE_CONSENT_TO_DUAL_REGISTRATION].formGroup, 'value')"
                            [trueValue]="'Tak'"
                            [falseValue]="'Nie'"
                          ></app-slide-toggle>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
                <span fxFlex="2"></span>
              </ng-container>
            </div>

            <div fxLayout="row">
              <div fxFlex="100">
                <mat-form-field fxFlex="100">
                  <mat-label>Aktualny podmiot rejestracji</mat-label>
                  <input [required]="false" matInput placeholder="Aktualny podmiot rejestracji" [formControl]="currentEntityOfRegistrationControl" >
                </mat-form-field>
              </div>
            </div>

            <div fxLayout="row">
              <div fxFlex="100">
                <mat-form-field fxFlex="100">
                  <mat-label>Uwagi</mat-label>
                  <input [required]="false" matInput placeholder="Uwagi" [formControl]="commentsControl" >
                </mat-form-field>
              </div>
            </div>

            <div *ngIf="(registrationObject.documentAnotherMulti)" fxLayout="row" fxLayoutGap="15px">
              <mat-slide-toggle fxFlex="33" formControlName="documentInformationScan" color="accent">Skan</mat-slide-toggle>
              <mat-slide-toggle fxFlex="33" formControlName="documentInformationOriginal" color="accent">Oryginał</mat-slide-toggle>
              <mat-slide-toggle fxFlex="33" formControlName="documentInformationDocumentMissing" color="accent">Brak dokumentu</mat-slide-toggle>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <mat-slide-toggle fxFlex="33" formControlName="registrationDocumentMissing" color="accent">Brak dokumentu</mat-slide-toggle>
            </div>

          </mat-card>
        </div>
      </div>



      <div fxLayout="row">
        <mat-card fxLayout="column" fxLayoutGap="15px" fxFlex="100">
          <div fxLayout="row">
            <h3>Blokada sprzedaży</h3>
          </div>

          <div fxLayout="row" fxLayoutGap="15px">
            <div fxFlex="50">
              <mat-slide-toggle  color="accent" formControlName="sentToBlock" (change)="sentToBlockChanged($event)">Wysłane do TU</mat-slide-toggle>
            </div>
            <div fxFlex="50">
              <mat-slide-toggle
              color="accent" formControlName="blocked"
                (change)="blockedChanged($event)"
              >Zablokowane</mat-slide-toggle>
            </div>
          </div>
        </mat-card>
      </div>

      <div fxLayout="row" *ngIf="DEREGISTER_STATUSES.includes(selectedStatus?.key)">
        <mat-card fxLayout="column" fxLayoutGap="15px" fxFlex="100">
          <div fxLayout="row">
            <h3>Wyrejestrowanie</h3>
          </div>

          <div fxLayout="row">
            <div fxFlex="100">
              <mat-slide-toggle color="accent" formControlName="agreedToDeregister">Zgoda ASF na wyrejestrowanie</mat-slide-toggle>
            </div>
          </div>

          <div fxLayout="row">
            <mat-form-field fxFlex="100">
              <mat-label>Powód wyrejestrowania</mat-label>
              <textarea [required]="true" formControlName="deregisterReason" matInput placeholder="Powód wyrejestrowania"></textarea>
            </mat-form-field>
          </div>

        </mat-card>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Uwagi</h3>
            </div>

            <div fxLayout="row" >
              <mat-form-field fxFlex="100">
                <mat-label>Uwagi</mat-label>
                <textarea formControlName="note" matInput placeholder="Uwagi"></textarea>
              </mat-form-field>
            </div>

          </mat-card>
        </div>
      </div>

    </div>

  </div>

  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="processingRequest || !registrationFormValid"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
